import { useState } from 'react';
import { useResendInvite } from '@/hooks/useResendInvite';

type PromoteAccountSuccessViewProps = {
  inviteUrl?: string | null;
  checkoutUrl: string | null;
  accountId: string;
  onClose: () => void;
};

export function PromoteAccountSuccessView({
  inviteUrl,
  checkoutUrl,
  accountId,
  onClose,
}: PromoteAccountSuccessViewProps) {
  const resend = useResendInvite(accountId);
  const [copied, setCopied] = useState(false);

  async function copyInvite() {
    if (!inviteUrl) {
      return;
    }
    await navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="detail-stack">
      <div>
        <p className="entity-breadcrumb">Customer Created</p>
        <h2>{inviteUrl ? 'Invite is ready' : 'Tenant is ready'}</h2>
        <p className="muted-copy">
          {inviteUrl
            ? 'The admin invite email has been queued. You can also share the link directly.'
            : 'The selected account user has been added as an active admin for the new tenant.'}
        </p>
      </div>

      {inviteUrl ? (
        <div className="callout-panel">
          <code className="break-anywhere">{inviteUrl}</code>
        </div>
      ) : null}

      {checkoutUrl ? (
        <div className="callout-panel">
          <p className="entity-breadcrumb">Payment Link</p>
          <code className="break-anywhere">{checkoutUrl}</code>
        </div>
      ) : null}

      <div className="entity-header-actions">
        {inviteUrl ? (
          <>
            <button
              type="button"
              className="button button-secondary"
              onClick={() => resend.mutate(undefined)}
              disabled={resend.isPending}
            >
              {resend.isPending ? 'Resending...' : 'Resend invite'}
            </button>
            <button type="button" className="button button-secondary" onClick={copyInvite}>
              {copied ? 'Copied' : 'Copy link'}
            </button>
          </>
        ) : null}
        <button type="button" className="button button-primary" onClick={onClose}>
          Done
        </button>
      </div>
    </div>
  );
}
